(function ($) {
    'use strict';
    /**
     * плагин масштабирвоания текста
     * */
    $.fn.mobileScrollerTable = function () {
        var classes = {
            textWrapper: '.imperavi-content',
            table: 'table'
        };
        var MOBILE_WIDTH = 768;

        var $self = $(this);
        var $textWrapper = $self.find(classes.textWrapper);

        /**
         * инициализация плагина
         * */
        var init = function () {
            if (window.innerWidth >= MOBILE_WIDTH) {
                return;
            }
            var child = $textWrapper.children();
            $textWrapper.empty();
            for (var i = 0; i < child.length; i++) {
                if (child[i].localName === 'table') {
                    var divClass = 'js-news-scroll-table-' + i;
                    var div = '<div class="news-scroll-table responsive-ceil ' + divClass + '"></div>';
                    $textWrapper.append(div);
                    var $div = $textWrapper.find('.' + divClass);
                    $div.append(child[i]);
                } else {
                    $textWrapper.append(child[i]);
                }
        }


        };
        init();
        return this;
    };
    $('.js-find-table').each(function () {
        $(this).data('mobileScrollerTable', $(this).mobileScrollerTable());
    });
})(jQuery);
